export default __webpack_public_path__ + "static/media/phone.877bf0f8.jpg";